import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import Button from "../../../components/Botton";
import Loader from "../../../components/Loader";
import ApiService from "../../../service/ApiService";
import { apiPaths } from "../../../service/apiPaths";

interface EditCouponCategoryProps {
  couponCategoryId: string;
  name: string;
  description: string;
}

const EditCouponCategoryIndex = ({ 
  
}) => {
  const location = useLocation()

  const {name , description} = location.state
  const [categoryName, setCategoryName] = useState(name|| "");
  const [categoryDescription, setCategoryDescription] = useState(description||"");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate()
  const {couponCategoryId} = useParams()



  // const fetchCouponCategoryDetails = async () => {
  //   if (!couponCategoryId) return;
    
  //   setLoading(true);
  //   try {
  //     const response = await axios.get(`/api/coupon-categories/${couponCategoryId}`);
      
  //     if (response.data) {
  //       setCategoryName(response.data.name);
  //       setCategoryName(response.data.description || "");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching coupon category details:", error);
  //     toast.error("Failed to load coupon category details");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!categoryName.trim()) {
      toast.error("Category name is required");
      return;
    }
    
    setLoading(true);
    try {
      const data = await ApiService({
        method:"PUT" ,
        endpoint:`${apiPaths.editCategory}/${couponCategoryId}` ,
        data:{
          name:categoryName ,
          description:categoryDescription
        }
      })
      
      toast.success("Coupon category updated successfully");
      navigate("/coupon-category");
    } catch (error: any) {
      console.error("Error updating coupon category:", error);
      
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Failed to update coupon category");
      }
    } finally {
      setLoading(false); 
    }
  };

  const handleCancel = () => {
    navigate("/coupon-category");
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      {loading && <Loader />}
      
      <h2 className="text-2xl font-semibold mb-6">Edit Coupon Category</h2>
      
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-gray-700 mb-2" htmlFor="categoryName">
            Category Name *
          </label>
          <input
            id="categoryName"
            type="text"
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
        </div>
        
        <div className="mb-6">
          <label className="block text-gray-700 mb-2" htmlFor="description">
            Description
          </label>
          <textarea
            id="description"
            value={categoryDescription}
            onChange={(e) => setCategoryDescription(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 h-32"
          />
        </div>
        
        <div className="flex justify-end space-x-4">
          <Button
            onClick={handleCancel}
            className="bg-gray-200 hover:bg-gray-300 py-2 px-4 rounded"
            children="Cancel"
            type="button"
          />
          <Button
            className="py-2 px-4 rounded"
            children="Save Changes"
            type="submit"
            onClick={()=>console.log('hi')}
          />
        </div>
      </form>
    </div>
  );
};

export default EditCouponCategoryIndex;
